const CDN_URL = process.env.NEXT_PUBLIC_CDN_URL;

interface IImages {
    crypto: { [key: string]: string },
    categories: { [key: string]: string },
    backgrounds: { [key: string]: string }
    cards: { [key: string]: string },
    misc: { [key: string]: string }
    funding: { [key: string]: string }
    oinkhub: { [key: string]: string }
}

const Images: IImages = {
    crypto: {
        BTCIcon: `${CDN_URL}/crypto/icons/btc-coin.png`,
        ETHIcon: `${CDN_URL}/crypto/icons/eth-coin.png`,
        BCHIcon: `${CDN_URL}/crypto/icons/bch-coin.png`,
        AVAXIcon: `${CDN_URL}/crypto/icons/avax-coin.png`,
        SOLIcon: `${CDN_URL}/crypto/icons/sol-coin.png`,
        BTCBg: `${CDN_URL}/crypto/backgrounds/btc-bg.png`,
        ETHBg: `${CDN_URL}/crypto/backgrounds/eth-bg.png`,
        BCHBg: `${CDN_URL}/crypto/backgrounds/bch-bg.png`,
        AVAXBg: `${CDN_URL}/crypto/backgrounds/avax-bg.png`,
        SOLBg: `${CDN_URL}/crypto/backgrounds/sol-bg.png`,
        SwitchIcon: `${CDN_URL}/crypto/icons/crypto-switch-icon.png`,
        NYIcon: `${CDN_URL}/crypto/icons/crypto-ny-icon.png`,
        WarningIcon: `${CDN_URL}/crypto/icons/crypto-warning-icon.png`,
    },
    categories: {
        EnergyUtilities: `${CDN_URL}/category/energy-utilities.png`,
        Etfs: `${CDN_URL}/category/etfs.png`,
        FinanceBanking: `${CDN_URL}/category/finance-banking.png`,
        FoodDrink: `${CDN_URL}/category/food-drink.png`,
        Health: `${CDN_URL}/category/health.png`,
        Industrial: `${CDN_URL}/category/industrial.png`,
        MediaTelecom: `${CDN_URL}/category/media-telecom.png`,
        ShoppingRetail: `${CDN_URL}/category/shopping-retail.png`,
        Technology: `${CDN_URL}/category/technology.png`,
        Top15: `${CDN_URL}/category/top15.png`,
        Dividends: `${CDN_URL}/category/dividends.png`,
        Tourism: `${CDN_URL}/category/tourism.png`,
        Crypto: `${CDN_URL}/category/crypto.png`,
        Transportation: `${CDN_URL}/category/transportation.png`,
    },
    backgrounds: {
        TransferPendingDarkBg: `${CDN_URL}/backgrounds/bg-transfer-pending-dark.png`,
        TransferCompleteDarkBg: `${CDN_URL}/backgrounds/bg-transfer-complete-dark.png`,
        TransferDeclinedDarkBg: `${CDN_URL}/backgrounds/bg-transfer-declined-dark.png`,
        OrderPendingDarkBg: `${CDN_URL}/backgrounds/bg-order-pending-dark.png`,
        OrderFulfilledDarkBg: `${CDN_URL}/backgrounds/bg-order-fulfilled-dark.png`,
        OrderCancelledDarkBg: `${CDN_URL}/backgrounds/bg-order-cancelled-dark.png`,
        OrderPendingBg: `${CDN_URL}/backgrounds/bg-order-pending.png`,
        OrderFulfilledBg: `${CDN_URL}/backgrounds/bg-order-fulfilled.png`,
        OrderCancelledBg: `${CDN_URL}/backgrounds/bg-order-cancelled.png`,
        InstantDepositBg: `${CDN_URL}/backgrounds/bg-instant-deposit.png`,
    },
    cards: {
        amex: `${CDN_URL}/cards/amex.png`,
        discover: `${CDN_URL}/cards/discover.png`,
        mastercard: `${CDN_URL}/cards/mastercard.png`,
        visa: `${CDN_URL}/cards/visa.png`,
        greenCheckShield: `${CDN_URL}/cards/green-check-shield.png`,
    },

    misc: {
        DepositTransitGraphic: `${CDN_URL}/images/deposit-transit-graphic.png`,
    },
    funding: {
        LinkBankWithPlaid: `${CDN_URL}/images/link-bank-with-plaid.png`,
    },
    oinkhub: {
        Oink: `${CDN_URL}/oinkhub/oink.png`,
    }
}

function getCdnUrl() {
    return CDN_URL
}

export {
    Images,
    getCdnUrl
};
